import { gql, useMutation } from '@apollo/client';
import { useEffect } from 'react';

import { checkModuleRight, useModuleRights } from '@work4all/data';

import { ModuleAccessRightType } from '@work4all/models/lib/Enums/ModuleAccessRightType.enum';

import { useMailboxesData } from '../../../../../../hooks/use-mailboxes-data';
import { settings, useSetting } from '../../../../../../settings';

const SEND_INVITE = gql`
  mutation SendAppointmentInvite(
    $senderMailAddress: String!
    $appointmentCode: Int!
  ) {
    sendAppointmentInvite(
      senderMailAddress: $senderMailAddress
      appointmentCode: $appointmentCode
    )
  }
`;

export const useSendAppointmentInvites = () => {
  const appointmentInviteMailbox = useSetting(
    settings.appointmentInviteMailbox()
  );

  const mailboxesData = useMailboxesData();

  useEffect(() => {
    if (mailboxesData.mailboxes.length) {
      if (!appointmentInviteMailbox.value) {
        appointmentInviteMailbox.set(
          mailboxesData.mailboxes[0].mailboxPrimaryAddress
        );
      } else {
        if (
          !mailboxesData.mailboxes.find(
            (x) => x.mailboxPrimaryAddress === appointmentInviteMailbox.value
          )
        ) {
          appointmentInviteMailbox.set(null);
        }
      }
    }
  }, [appointmentInviteMailbox, mailboxesData.mailboxes]);

  const invite = useMutation<
    boolean,
    { senderMailAddress: string; appointmentCode: number }
  >(SEND_INVITE, {
    context: { batch: false },
  });

  const { rights } = useModuleRights();
  const isAvailable = checkModuleRight(
    rights,
    ModuleAccessRightType.FEATURE_EXCHANGE_CONNECTOR_4
  );

  return {
    invite,
    appointmentInviteMailbox: appointmentInviteMailbox.value,
    setAppointmentInviteMailbox: appointmentInviteMailbox.set,
    isAvailable,
  };
};
